import React from 'react'
import {
  faCircleCheck,
  faIdCard,
  faUserCheck,
  faUsers,
} from '@fortawesome/free-solid-svg-icons'
import Summary from '../components/Summary'
import { formatNumber } from '../utils/formatter'

// Catatan di bawah setiap kartu memakai angka yang sudah ada: porsi tiap
// status terhadap total pendaftar.
const percentOf = (value, total) => {
  if (!total) {
    return '0%'
  }
  return `${Math.round((Number(value ?? 0) / total) * 100)}%`
}

const SummaryStats = ({ pendaftarOnline, verifiedKorwil, disetujui, total }) => {
  return (
    <Summary
      data={[
        {
          title: 'Pendaftar Online',
          value: formatNumber(pendaftarOnline),
          icon: faUsers,
          accentColor: '#277FFB',
          note: 'Dari total pendaftar',
          noteValue: percentOf(pendaftarOnline, total),
        },
        {
          title: 'Verified oleh Korwil',
          value: formatNumber(verifiedKorwil),
          icon: faUserCheck,
          accentColor: '#059669',
          note: 'Dari total pendaftar',
          noteValue: percentOf(verifiedKorwil, total),
        },
        {
          title: 'Disetujui',
          value: formatNumber(disetujui),
          icon: faCircleCheck,
          accentColor: '#D97706',
          note: 'Dari total pendaftar',
          noteValue: percentOf(disetujui, total),
        },
        {
          title: 'Total Pendaftar',
          value: formatNumber(total),
          icon: faIdCard,
          accentColor: '#2B2C2C',
          note: 'Sudah disetujui',
          noteValue: percentOf(disetujui, total),
        },
      ]}
    />
  )
}

export default SummaryStats
